import { z } from 'zod';

const contractStatusEnum = z.enum(['requested', 'received', 'signed']);

export const createContractSchema = z.object({
  itemId: z.string().uuid('Invalid item ID'),
  quoteId: z.string().uuid().nullable().optional(),
  status: contractStatusEnum.optional().default('requested'),
  totalAmount: z.number().int().min(0),
  notes: z.string().max(2000).nullable().optional(),
});

export const updateContractSchema = z.object({
  status: contractStatusEnum.optional(),
  totalAmount: z.number().int().min(0).optional(),
  signedAt: z.string().datetime().nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
  vendorId: z.string().uuid().nullable().optional(),
});

export const createPaymentSchema = z.object({
  contractId: z.string().uuid('Invalid contract ID'),
  description: z.string().min(1, 'Description is required').max(255),
  amount: z.number().int().min(0),
  dueDate: z.string().date('Invalid date').nullable().optional(),
  dueDateDescription: z.string().max(500).nullable().optional(),
  sortOrder: z.number().int().min(0).optional().default(0),
});

export const updatePaymentSchema = z.object({
  description: z.string().min(1).max(255).optional(),
  amount: z.number().int().min(0).optional(),
  dueDate: z.string().date().nullable().optional(),
  dueDateDescription: z.string().max(500).nullable().optional(),
  paidAt: z.string().datetime().nullable().optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export const createInvoiceSchema = z.object({
  contractId: z.string().uuid('Invalid contract ID'),
  invoiceNumber: z.string().max(100).nullable().optional(),
  issuedAt: z.string().datetime().nullable().optional(),
  totalAmount: z.number().int().min(0),
  notes: z.string().max(2000).nullable().optional(),
});

export const updateInvoiceSchema = z.object({
  invoiceNumber: z.string().max(100).nullable().optional(),
  issuedAt: z.string().datetime().nullable().optional(),
  totalAmount: z.number().int().min(0).optional(),
  notes: z.string().max(2000).nullable().optional(),
});

export type CreateContractInput = z.input<typeof createContractSchema>;
export type UpdateContractInput = z.input<typeof updateContractSchema>;
export type CreatePaymentInput = z.input<typeof createPaymentSchema>;
export type UpdatePaymentInput = z.input<typeof updatePaymentSchema>;
export type CreateInvoiceInput = z.input<typeof createInvoiceSchema>;
export type UpdateInvoiceInput = z.input<typeof updateInvoiceSchema>;
